import { Injectable } from '@angular/core';
import { CodeSystemService } from '@xt/data-access';
import { of } from 'rxjs';

@Injectable()
export class CurCodeSystemService extends CodeSystemService {
  override getItemById$(url: string, disableCache: boolean) {
    return of([]);
  }
}
